import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { get, map as _map, mapValues, keyBy } from 'lodash';
import { HttpClient, HttpParams } from '@angular/common/http';
import { forkJoin, Observable, ReplaySubject } from 'rxjs';
import { LoadReferenceDataItemPayload } from './load-reference-data-item-payload';
import * as momentNs from 'moment';
import { Store, select } from '@ngrx/store';
import * as fromRoot from './reference-data.reducers';
import { TypedReferenceData } from './models/typed-reference-data';
import { GenericReferenceData } from './models/generic-reference-data';
import { LoadReferenceDataItemAction, LoadReferenceDataAction } from './reference-data.actions';
// tslint:disable-next-line:no-any typedef
const moment = momentNs;

@Injectable({
  providedIn: 'root',
})
export class ReferenceDataManagementUiLibraryService<T extends GenericReferenceData> {

  constructor(
    private http: HttpClient,
    private store: Store<fromRoot.State>
  ) {
  }

  loadReferenceDataItem(payload: LoadReferenceDataItemPayload<T>):
    Observable<TypedReferenceData<T>> {
    let httpParams: HttpParams = new HttpParams().set('date', !!payload.date ? payload.date : moment().format('YYYY-MM-DD'));
    return this.http.get(`${payload.url}`, { params: httpParams }).pipe(
      // tslint:disable-next-line:no-any
      map((data: any[]) => {
        // tslint:disable-next-line:no-any
        return _map(data, (d: any) => {
          let item: T = new payload.generic(d);
          return item;
        });
      }),
      map((referenceData: T[]) => {
        return {
          type: payload.type,
          loaded: true,
          referenceData,
        };
      }),
    );
  }

  get referenceData(): Observable<{[type: string]: {[correlationId: string]: T}}> {
    return this.store.pipe(
      select(fromRoot.getReferenceDataEntities),
      map((referenceData: {[type: string]: TypedReferenceData<T>}) => {
        return mapValues(referenceData, (d: TypedReferenceData<T>) => {
          return keyBy(d.referenceData, 'correlationId.correlation');
        });
      }),
    );
  }

  loadReferenceDataItems(payload: LoadReferenceDataItemPayload<T>[]):
    Observable<TypedReferenceData<T>[]> {
    return forkJoin(
      _map(payload, (data: LoadReferenceDataItemPayload<T>) => this.loadReferenceDataItem(data)),
    );
  }

  getReferenceData(type: string): Observable<T[]> {
    return this.store.pipe(
      select(fromRoot.getReferenceDataEntities),
      map((referenceData: {[type: string]: TypedReferenceData<T>}) =>
        get(get(referenceData, type), 'referenceData')),
    );
  }

  getTypedReferenceData(type: string): Observable<TypedReferenceData<T>> {
    return this.store.pipe(
      select(fromRoot.getReferenceDataEntities),
      map((referenceData: {[type: string]: TypedReferenceData<T>}) => get(referenceData, type)),
    );
  }

  dispatchLoadReferenceDataItem(payload: LoadReferenceDataItemPayload<T>): void {
    this.store.dispatch(new LoadReferenceDataItemAction(payload));
  }

  dispatchLoadReferenceData(payload: LoadReferenceDataItemPayload<T>[]): void {
    this.store.dispatch(new LoadReferenceDataAction(payload));
  }
}
